import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { OptionService } from 'src/app/options/option.service';
import { PermissionService } from 'src/app/systemsettings/permissions/permission.service';
import { menuPerm } from '../menuPerm.model';
import { DirectChargeService } from 'src/app/options/direct-charge-orders/direct-charge.service';
import { DeviceService } from 'src/app/options/device-approvals/device.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';


@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
    standalone: false
})
export class MainComponent implements OnInit {

  userFullName: string = "";
  role: string = "";
  roleId!: string;
  userId!: string;
  menuPerm: menuPerm[] = [];
  notSeenMessageCount = 0;
  notSeenDirectChargeCount = 0;
  // sign-in attempts from new devices waiting for the admin
  pendingDevicesCount = 0;
  private knownPendingDeviceIds: number[] | null = null;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  direction!: any;
  constructor(private breakpointObserver: BreakpointObserver,
    private localStorage: LocalStorageService,
    private authService: AuthService,
    private permissionService: PermissionService,
    private optionService: OptionService,
    private direcChargeService: DirectChargeService,
    private deviceService: DeviceService,
    private snackBar: MatSnackBar,
    private router: Router,
    private translate: TranslateService) { }

  ngOnInit(): void {

    this.userFullName = this.localStorage.retrieve("userInfo").fullName;
    this.role = this.localStorage.retrieve("userInfo").role;
    this.roleId = this.localStorage.retrieve("userInfo").roleId;
    this.userId = this.localStorage.retrieve("userInfo").userId;
    this.selectChange();
    this.getMenu();
    this.getNotSeenMessageCount();
    this.getNotSeenDirectChargeCount();
    setInterval(() =>

      this.getNotSeenMessageCount(),

      30000);

    setInterval(() =>

      this.getNotSeenDirectChargeCount(),

      30000);

    if (this.role == 'Admin') {
      this.getPendingDevices();
      setInterval(() => this.getPendingDevices(), 30000);
    }
  }

  /// The admin is told the moment a new device tries to sign in, so they can
  /// accept or refuse it while the user is still waiting.
  getPendingDevices() {
    this.deviceService.getPending().subscribe(response => {
      const devices = response.data || [];
      this.pendingDevicesCount = devices.length;

      const ids = devices.map(x => x.id);
      if (this.knownPendingDeviceIds !== null) {
        const fresh = devices.filter(x => this.knownPendingDeviceIds!.indexOf(x.id) < 0);
        if (fresh.length > 0) {
          const who = fresh[0].fullName || fresh[0].userName || "";
          const ref = this.snackBar.open(
            this.translate.instant("newDeviceAlert") + " " + who + " (" + (fresh[0].deviceName || fresh[0].platform || "") + ")",
            this.translate.instant("view"),
            { duration: 15000, horizontalPosition: 'end', verticalPosition: 'top', panelClass: 'snackBarError' });
          ref.onAction().subscribe(() => this.router.navigate(['/master/options/deviceapprovals']));
        }
      }
      this.knownPendingDeviceIds = ids;
    }, error => {
      console.log(error);
    })
  }

  getNotSeenMessageCount() {
    this.optionService.getNotSeenMessageCount().subscribe(data => {
      this.notSeenMessageCount = data;
    }, error => {
      console.log(error);
    })
  }

  getNotSeenDirectChargeCount() {
    this.direcChargeService.getNotSeenCount().subscribe(data => {
      this.notSeenDirectChargeCount = data;
    }, error => {
      console.log(error);
    })
  }

  onClickMessages() {
    this.updateMessagesSeen();
  }

  updateMessagesSeen() {
    this.optionService.updateNotSeenMessage().subscribe(data => {
      this.getNotSeenMessageCount();
    },
      error =>
        console.log(error))
  }

  updateDirectChargeSeen() {
    this.direcChargeService.updateNotSeen().subscribe(data => {
      this.getNotSeenDirectChargeCount();
    },
      error =>
        console.log(error))
  }

  onClickDirectCharge() {
    this.updateDirectChargeSeen();
  }

  selectChange() {
    var body = document.getElementsByTagName('body')[0];
    var html = document.getElementsByTagName('html')[0];
    body.removeAttribute("dir");
    html.removeAttribute("dir");
    this.localStorage.retrieve("lang") == 0 ? this.direction = "ltr" : this.direction = "rtl";
    this.localStorage.retrieve("lang") == 0 ? this.translate.use('en') : this.translate.use('ar');

    if (this.localStorage.retrieve("lang") == 0) {

      body.setAttribute("dir", "ltr");
      html.setAttribute("dir", "ltr");
    }
    else {
      body.setAttribute("dir", "rtl");
      html.setAttribute("dir", "rtl");
    }

  }

  logout() {
    this.authService.logout();
  }

  getMenu() {
    this.permissionService.getMenu(this.userId).subscribe(data => {
      this.menuPerm = data;
    }, error => {
      console.log(error);
    })
  }

}

